import RegularBox from './RegularBox';

export default RegularBox;
